import { render } from "./AuthentificationForm.vue?vue&type=template&id=7f9e45f9&ts=true"
import script from "./AuthentificationForm.vue?vue&type=script&lang=ts"
export * from "./AuthentificationForm.vue?vue&type=script&lang=ts"

import "./AuthentificationForm.vue?vue&type=style&index=0&id=7f9e45f9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__